import React from "react";
import { PRIVACY_POLICY, TOS } from "../../constants";
import "./styles/privacy-tos.scss";

export function PrivacyPolicyTos() {
  return (
    <div className="privacy-tos-container d-flex mt-auto pb-2 px-2">
      <a href={PRIVACY_POLICY} target="_blank" rel="noreferrer">
        Privacy Policy
      </a>
      <span className="mx-2">&nbsp;|&nbsp;</span>
      <a href={TOS} target="_blank" rel="noreferrer">
        Terms of Service
      </a>
    </div>
  );
}

export default PrivacyPolicyTos;
